import React, { useState , useContext  ,  useEffect} from 'react'
import TeamsInfo from './TeamsInfo'
import Performans from './Performans'
import BeetweenMatch from './BeetweenMatch'
import NextMatches from './NextMatches'
import LastMatches from './LastMatches'
import Loading from '../Loading'
import DataFetch  from '../../Context/DataFetch'
import  Language from '../../Context/Language'


export default function HeadAll() {
  const {loading , data} = useContext(DataFetch)
  const dataLang = useContext(Language)
  const [title, setTitle] = useState("SR-H2H");
  useEffect(() => {
    document.title = title;
  }, [title]);
  

  return (
   
               loading ?
               <div className='H2HRootContainerArea'>
                <Loading/>
               </div>

               : 

               data.length !==0 ?

               <div className='H2HRootContainerArea'>
               <TeamsInfo/>
               <Performans/>
               <BeetweenMatch/>
               <LastMatches/>
                <NextMatches/>
               </div>

               :
               <div className='DATANOTFOUNDDİV'>
                <div>{dataLang[sessionStorage.getItem("lang")].Nodata}</div>
               </div>

  )
}
